"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureResourceManager = void 0;
/** {@inheritDoc IFeatureResourceManager} */
class FeatureResourceManager {
    constructor() {
        this.resources = {};
    }
    resourceKey(resource) {
        return [resource.type, resource.identifier].join('|');
    }
    resourceKeyFromStrings(type, identifier) {
        return [type, identifier].join('|');
    }
    /** {@inheritDoc IFeatureResourceManager.addResource} */
    addResource(resource) {
        const storedResource = resource;
        if (!storedResource.identifier) {
            throw new Error(`Resource of type '${resource.type}' is missing an identifier.`);
        }
        if (this.getResource(storedResource.type, storedResource.identifier)) {
            throw new Error(`Resource '${storedResource.identifier}' has already been defined.`);
        }
        this.resources[this.resourceKey(storedResource)] = storedResource;
    }
    /** {@inheritDoc IFeatureResourceManager.getResource} */
    getResource(type, identifier) {
        const resource = this.resources[this.resourceKeyFromStrings(type, identifier)];
        return resource ? resource : null;
    }
    /** {@inheritDoc IFeatureResourceManager.getResourcesForType} */
    getResourcesForType(type) {
        return Object.values(this.resources).filter(resource => {
            return resource.type === type;
        });
    }
}
exports.FeatureResourceManager = FeatureResourceManager;
//# sourceMappingURL=FeatureResourceManager.js.map